import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
  & > button {
    background-color: #1B49EA;
    color: #ffffff;
    border-radius: 8px;
    padding: 12px 17px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    & > div {
      height: 15px;
      overflow: hidden;
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
`;
export const FilterWrapDiv = styled.div`
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 36px;
  margin-bottom: 20px;
  & input {
    width: 115px;
    margin-right: 12px;
  }
  & > div {
    margin-right: 12px;
    &:last-child {
      margin-right: 0px;
    }
  }
`;
export const SearchDiv = styled.div`
  position: relative;
  & img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  & input {
    height: 38px;
    width: 200px;
    margin: 0px;
    padding: 0px 12px 0px 40px;
  }
`;
export const CardDiv = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: 0px 36px auto 36px;
`;
export const QuestionTable = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
  & th {
    padding: 14px 30px;
    background-color: #EDEFF1;
  }
  & tr {
    border-bottom: 1px solid #ececec;
  }
  & td {
    padding: 24px 30px;
    & > div {
      display: flex;
      align-items: center;
      & > button {
        height: 32px;
        width: 32px;
        background: none;
        padding: 6px;
        border-radius: 4px;
        &:hover {
          background: #edf0fe;
        }
      }
    }
  }
`;
export const UpdateLink = styled(Link)`
  height: 32px;
  width: 32px;
  background: none;
  padding: 6px;
  border-radius: 4px;
  box-sizing: border-box;
  &:hover {
    background: #edf0fe;
  }
`;
export const AddLink = styled(Link)`
  height: 40px;
  background-color: #1B49EA;
  color: #ffffff;
  border-radius: 8px;
  padding: 8px 17px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  text-decoration: none;
  box-sizing: border-box;
  & > span {
    height: 15px;
    overflow: hidden;
    margin-right: 8px;
    margin-bottom: 3px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  &:hover {
    color: #ffffff;
  }
`;
